import styled from 'styled-components';
import { Colors } from '../../shared/colors/colors';

export const LabelCount = styled.p`
  font-size: 14px;
  color: ${Colors.primary};
  margin-left: 3px;
`;

export const ContainerCount = styled.div`
  display: flex;
`;
